<template>
    <main-layout>
        <template #header>
            <main-header :title="'다국어관리' | translate">
            </main-header>
        </template>

        <template #toolbar>
            <div>
                <v-checkbox v-model="searchOptions.untranslated" label="미번역 보기">
                </v-checkbox>
            </div>
            <div v-if="userManager.hasPermission(Permissions.SYSTEM.TRANSLATE__SELECT_LOCALE)" class="ml-5">
                <search-single-select-box
                        :items="languageOptions"
                        :label="'언어 선택'"
                        @update:selected="onFilterChanged"
                        style="width: 150px;"
                        v-model="searchOptions.language"
                >
                </search-single-select-box>
            </div>
            <v-spacer></v-spacer>
            <div style="width: 1000px;">
                <search-bar
                        v-model="searchOptions.searchKeyword"
                        :placeholder="'메시지키/메시지' | translate"
                        @update:keyword="onFilterChanged"
                />
            </div>
        </template>

        <template #body>
            <div style="display: flex; align-items: center;">
                <div v-if="userManager.hasPermission(Permissions.SYSTEM.TRANSLATE__ADD)" style="display: flex; align-items: center;" class="mb-5" >
                    <div style="width: 500px;" class="mr-3">
                        <v-text-field v-model="messagekey" outlined dense placeholder="한국어 메시지키 추가" hide-details></v-text-field>
                    </div>
                    <v-btn color="primary" @click="onClickAdd">키 추가(한국어)</v-btn>
                </div>
                <v-spacer></v-spacer>
                <div class="ml-5">
                    <v-btn icon @click="onClickRefresh">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </div>
            </div>
            <mps-data-table
                    ref="dataTable"
                    :next="next"
                    :headers="headers">
                <template #item.delete="{ item }">
                    <v-btn icon @click.stop="onClickDelete(item.raw.multilanguageId)" v-if="item.raw.multilanguageId">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <span v-else>-</span>
                </template>
            </mps-data-table>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainHeader from "@/components/common/layout/MainHeader";
    import SearchBar from "@/components/input/SearchBar";
    import MpsDataTable from "@/assets/plugins/mps-form-table/component/mps-data-table/MpsDataTable";
    import {PATH} from "@/constants";
    import Multilanguage from "@/model/multilanguage";
    import {FORM_TABLE_OPTION} from "@/assets/plugins/mps-form-table/constants/form-table-const";
    import userManager from "@/assets/plugins/mps-common/user/user-manager";
    import SearchSingleSelectBox from "@/components/input/SearchSingleSelectBox";
    import TotalCodeOptions from "@/assets/options/TotalCodeOptions";

    export default {
        name: "MultilanguageList",
        mixins: [TotalCodeOptions],
        components: {
            SearchSingleSelectBox,
            MpsDataTable,
            SearchBar,
            MainHeader,
            MainLayout,
        },
        data() {
            return {
                headers: [
                    {
                        text: '언어',
                        key: 'locale',
                        read: (v, item) => ((item.raw.languageCode || "").toLowerCase()) + "-" + ((item.raw.countryCode || "").toUpperCase()),
                        width: 100,
                    },
                    {
                        text: '메시지키',
                        key: 'raw.messagekey',
                        width: 600,
                        align: "left",
                        sortable: true,
                    },
                    {
                        text: '메시지',
                        key: 'raw.message',
                        width: 720,
                        align: "start",
                        editable: true,
                        sortable: true,
                        update: (item) => item.updateOrAdd(),
                    },
                    // {
                    //     text: '삭제',
                    //     key: 'delete',
                    //     width: 80,
                    // },
                ],
                searchOptions: {
                    searchKeyword: "",
                    untranslated: true,
                    /* 언어선택 권한이 있으면 모든언어를 볼 수 있고 그 외는 자기가 속한 지역의 언어만 볼 수 있습니다. */
                    // language: userManager.hasPermission(Permissions.SYSTEM.TRANSLATE__SELECT_LOCALE) ? null : userManager.locale,
                    language: userManager.locale,
                },
                // 다국어 추가 메시지키 모델입니다.
                messagekey: "",
            }
        },
        watch: {
            "searchOptions.untranslated"() {
                this.onFilterChanged();
            },

            "searchOptions.language"(newValue) {
                if (!newValue) this.searchOptions.language = userManager.locale;
            },
        },
        created() {
            this.loadAllLanguages();
        },
        methods: {
            async next(pageNumber, pageSize) {
                const res = await this.$request(PATH.MULTILANGUAGE.LIST)
                    .setObject({
                        ...this.searchOptions,
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                    })
                    .catch()
                    .enqueue();

                return res.data.map(e => {
                    const model = new Multilanguage(e);
                    model._item.multilanguageId || model.untranslate(this.searchOptions.language);
                    return model;
                });
            },

            /**
             * 필터 조건이 변경되었습니다. 목록을 초기화하고 다시 불러옵니다.
             */
            onFilterChanged() {
                this.$refs.dataTable.clearAndNext();
            },

            /**
             * 다국어 키를 추가합니다.
             */
            async onClickAdd() {
                const model = new Multilanguage({messagekey: this.messagekey});
                model.readyForAdd(); // 추가를 위한 준비를 합니다.
                try {
                    await model.add();
                    this.messagekey = "";
                } catch (e) {
                    console.error(e);
                    this.$alert(e.response.data.hri || "Unkown Error!");
                }
            },

            /**
             * 데이터를 다시 로드합니다.
             */
            onClickRefresh() {
                this.$refs.dataTable.clearAndNext();
            },
        },
    }
</script>

<style scoped>

</style>
